import React from "react";
import cat from "./cat_mf.mp4"
import style from "./plug.css"

const Plug = ({message}) => {

    return (
        <div className={"plugFullscreen"}>
            <div className={"videoBlock"}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                >
                    <source
                        src={cat}
                        type="video/mp4"
                    />
                </video>
            </div>
            <h2 className={"plugMessage"}>Упсс! Что-то пошло не так.</h2>
            <h2 className={"plugMessage"}>{message}</h2>
            <button className={"plugBtn"} onClick={()=>window.location.reload()}>Повторить попытку</button>
        </div>
    )

}

export default Plug;
